const products = {
    products: {
        HaifaStimBooster: "Stimule l`activité métabolique dans les situations de stress ",
        HaifaStimEnergy: "Améliore le bilan énergétique de la plante ",
        HaifaStimForce: "Sauvegarde l`énergie métabolique`, `aide les acides aminés et la synthèse des protéines ",
        HaifaStimHumiK: "Favorise l`activité des racines et l`absorption des nutriments ",
        HaifaStimVigor: "Renforce et améliore la résistance des plantes aux stress abiotiques ",
        HaifaStimVIM: "Améliore la fertilité du sol et l`efficacité de l`utilisation des nutriments ",
        HaifaStimVital: "Améliore la performance des plantes ",
        HaifaStimWallUp:
            "Mélange optimal de micronutriments sélectionnés pour améliorer la résistance des plantes aux stress abiotiques`, `renforcer la croissance et maximiser le rendement",
        HaifaMicroCombi:
            "Un mélange stable`, `hydrosoluble et non poussiéreux de chélates de métaux`, `fer`, `manganèse`, `cuivre`, `zinc`, `tous présents sous forme chélatée d`EDTA. ",
        PolyFeedFoliar1:
            "Poly-Feed™ Foliar nourrit les plantes`, `répondant à leurs besoins précis pendant les phases de croissance clés pour des rendements maximaux et une qualité supérieure. ",
        PolyFeedFoliar2: "Formule spécifique pour les semences ",
        PolyFeedStim: "combinaison unique de stimulants naturels et d`engrais minéraux NPK ",
        HaifaBonus:
            "Engrais hautement potassique pour une application foliaire efficace. Les formules sont basées sur le nitrate de potassium Multi-K™ de Haïfa.",
    },
};

export default products;
